<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      row-key="id"
      :data='tableData'
      :tree-props="{children: 'children'}"
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '名称'>
      </el-table-column>
      <el-table-column
        prop= 'url'
        label= '链接'>
      </el-table-column>
      <el-table-column
        prop= 'descr'
        label= '描述'>
      </el-table-column>
      <el-table-column
        prop= 'parentId'
        label= '父级id'>
      </el-table-column>
      <el-table-column
        prop= 'sort'
        label= '排序;降序'>
      </el-table-column>
      <el-table-column
        prop= 'icon'
        label= '图标'>
      </el-table-column>

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '160'>
        <template slot-scope='scope'>
          <el-button @click='addChild(scope.row)' type='text' size='small' style="color: #209323" v-if="scope.row.parentId===0">添加子菜单</el-button>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible">
            <el-form :model="form">
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth">
          <el-input v-model="form.descr" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="链接" :label-width="formLabelWidth">
          <el-input v-model="form.url" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="父级ID" :label-width="formLabelWidth">
          <el-input v-model="form.parentId" autocomplete="off" :readonly="true"></el-input>
        </el-form-item>
        <el-form-item label="排序;降序" :label-width="formLabelWidth">
          <el-input v-model="form.sort" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="图标" :label-width="formLabelWidth">
          <el-input v-model="form.icon" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  data () {
    return {
      tableData: [],
      name: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        url: null,
        descr: null,
        name: null,
        parentId: null,
        sort: null,
        icon: null
      },
      formLabelWidth: '120px'
    }
  },
  created () {
    this.query()
  },
  methods: {
    del (row) {
      let that = this
      console.log('del')
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/permission/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      console.log('delClose')
      document.body.click()
    },
    query () {
      let that = this
      requestService.get('/permission/list?dealTree=true', {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.tableData = res.data.body
        console.log(that.tableData)
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
    },
    digAdd () {
      this.form = {}
      this.dialogFormVisible = true
    },
    addChild (row = {}) {
      this.form = {}
      this.form.parentId = row.id
      this.dialogFormVisible = true
    },
    submitForm () {
      let that = this
      that.dialogFormVisible = false
      console.log('add')
      let url = '/permission/add'
      if (that.form.id) {
        url = '/permission/edit'
      } else if (this.form.parentId) {
        url = '/permission/addChild'
      }
      requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
        that.query()
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/manage-components/permission/Index.vue